import { useCallback, useEffect, useState } from "react";
import { APIGetInstitutionDeeplinks } from "./APIs/masterAdmin/deeplinksApi.js";
import { useAuth } from "./useAuth.js";

const sortDeeplinks = (deeplinks) =>
  [...deeplinks].sort((a, b) =>
    String(a.label ?? "").localeCompare(String(b.label ?? ""))
  );

export const useInstitutionDeeplinks = (institutionId) => {
  const { token } = useAuth();
  const [deeplinks, setDeeplinks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDeeplinks = useCallback(async () => {
    if (!institutionId || !token) {
      setDeeplinks([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const response = await APIGetInstitutionDeeplinks(
      institutionId,
      setLoading,
      token
    );
    if (response?.status === 200) {
      const items = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data)
          ? response.data
          : [];
      setDeeplinks(sortDeeplinks(items));
      return;
    }

    setDeeplinks([]);
  }, [institutionId, token]);

  useEffect(() => {
    fetchDeeplinks();
  }, [fetchDeeplinks]);

  return { deeplinks, loading, refetch: fetchDeeplinks };
};
